'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("classificationService", function ($modal, $http, $dialogBox, $q, contextService) {
  var createPopinOptions = {
    controller: "ClassificationCreationPopinController",
    template: require("./classificationCreationPopin.html")
  };
  var createChampAdditionnelPopinOptions = {
    controller: "ChampAdditionnelCreationPopinController",
    template: require("./champAdditionnelCreationPopin.html")
  };
  var editionValeursPopinOptions = {
    controller: "ClassificationValeursEditionPopinController",
    template: require("./valeur/classificationValeursEditionPopin.html")
  };

  /**
   * champs additionnels quelque soit leur type
   */
  var classifications = null;
  var loadIfRequired = function loadIfRequired(cible) {
    if (classifications == null) {
      return doServerSync();
    } else {
      return classifications[cible];
    }
  };
  var doServerSync = function doServerSync() {
    var deferred = $q.defer();
    $http.get("/rest/saisie/champAdditionnel/list").then(function (response) {
      classifications = response.data;
      deferred.resolve(classifications);
    });
    return deferred.promise;
  };
  return {
    $reload: function $reload() {
      return doServerSync();
    },
    /**
     * champs additionnels et classifications
     * @returns {*}
     */
    findAllMultiplesCibles: function findAllMultiplesCibles(cibles) {
      var requetes = [];
      cibles.forEach(function (cible) {
        requetes.push(loadIfRequired(cible));
      });
      return $q.all(requetes).then(function () {
        return _.filter(classifications, function (c) {
          return !cibles || cibles.includes(c.cible);
        });
      });
    },
    /**
     * champs additionnels et classifications
     * @returns {*}
     */
    findAll: function findAll(cible) {
      return $q.when(loadIfRequired(cible)).then(function () {
        return _.filter(classifications, function (c) {
          return !cible || c.cible === cible;
        });
      });
    },
    /**
     * hors classification
     * @returns {*}
     */
    findAllChampsAdditionnels: function findAllChampsAdditionnels(cible) {
      return $q.when(loadIfRequired()).then(function () {
        return _.filter(classifications, function (c) {
          return c.type !== 'CLASSIFICATION' && (!cible || c.cible === cible);
        });
      });
    },
    /**
     * hors champs additionnels
     * @returns {*}
     */
    findAllClassifications: function findAllClassifications(cible) {
      return $q.when(loadIfRequired()).then(function () {
        return _.filter(classifications, function (c) {
          return c.type === 'CLASSIFICATION' && (!cible || c.cible === cible);
        });
      });
    },
    /**
     * hors champs additionnels
     * @returns {*}
     */
    findAllClassificationsForAnyCible: function findAllClassificationsForAnyCible(cibles) {
      return $q.when(loadIfRequired()).then(function () {
        return _.filter(classifications, function (c) {
          return c.type === 'CLASSIFICATION' && (cibles.length == 0 || _.includes(cibles, c.cible));
        });
      });
    },
    openCreationPopin: function openCreationPopin(cible, classifications) {
      return $modal.open(_.extend(createPopinOptions, {
        vars: {
          edit: false,
          cible: cible,
          classifications: classifications
        }
      }));
    },
    openEditionPopin: function openEditionPopin(classification, classifications) {
      return $modal.open(_.extend(createPopinOptions, {
        vars: {
          classification: classification,
          cible: classification.cible,
          edit: true,
          classifications: classifications
        }
      }));
    },
    openChampAdditionnelCreationPopin: function openChampAdditionnelCreationPopin(cible) {
      return $modal.open(_.extend(createChampAdditionnelPopinOptions, {
        vars: {
          edit: false,
          cible: cible
        }
      }));
    },
    openChampAdditionnelEditionPopin: function openChampAdditionnelEditionPopin(classification) {
      return $modal.open(_.extend(createChampAdditionnelPopinOptions, {
        vars: {
          classification: classification,
          edit: true
        }
      }));
    },
    /**
     * Suppression de la classification. Si echec, affiche un message d'erreur
     * @param classificationId
     * @returns {*}
     */
    delete: function _delete(classificationId) {
      return $http.delete("/rest/saisie/champAdditionnel/delete/" + classificationId).then(function (response) {
        var result = response.data;
        if (!result.valid) {
          $dialogBox.alert({
            title: "Impossible de supprimer la classification",
            text: result.message
          });
        } else {
          // on a supprimé un filtre, il faut recharger
          contextService.reloadContext();
          contextService.refreshData();
        }
        return result;
      });
    },
    /**
     *
     * @return normalement une valeur directement (et non une promesse)
     */
    findById: function findById(classificationId) {
      // TODO CP2
      return $q.when(loadIfRequired()).then(function () {
        for (var i = 0; i < classifications.length; i++) {
          if (classifications[i].id === classificationId) {
            return classifications[i];
          }
        }
        return null;
      });
    },
    /**
     *
     * @param appId optionnel, ne retourne que ceux associés à l'application
     * @return {*} retourne la promise
     */
    findAllByAppId: function findAllByAppId(appId, cible) {
      return $http.get("/rest/saisie/champAdditionnel/list/" + cible, {
        params: {
          appId: appId
        }
      }).then(function (result) {
        return result.data;
      });
    },
    findAllTypeClassificationByAppId: function findAllTypeClassificationByAppId(appId, cible) {
      return $http.get("/rest/saisie/champAdditionnel/classificationsPourCible/" + cible, {
        params: {
          appId: appId
        }
      }).then(function (result) {
        return result.data;
      });
    },
    findAllTypeClassificationByAppIdByCibles: function findAllTypeClassificationByAppIdByCibles(appId, cibles) {
      return $http.get("/rest/saisie/champAdditionnel/classificationsPourCibles", {
        params: {
          appId: appId,
          cibles: cibles
        }
      }).then(function (result) {
        return result.data;
      });
    },
    openEditionValeursPopin: function openEditionValeursPopin(classification) {
      return $modal.open(_.extend(editionValeursPopinOptions, {
        vars: {
          classification: classification
        }
      }));
    },
    getRendu: function getRendu() {},
    /**
     * peut traiter tous les champs additionnels (classifs ou champs)
     * @param classifications les champs additionnels à traiter
     * @param columns
     * @param withSubtotalGroup permet d'afficher l'icone de groupement / degroupement
     * @param principal true / false ou undefined pour les 2
     */
    addInventaireClassificationColumns: function addInventaireClassificationColumns(classifications, columns, withSubtotalGroup, principal) {
      /**
       * alignement de la cellule en fonction du type de classification (ou d'une carac de la classification)
       */
      function classificationFieldAlign(classification) {
        switch (classification.type) {
          case 'STRING':
            return "align-l";
          case 'LONG':
            return "align-r";
          case 'DOUBLE':
            return "align-r";
          case 'DATEMIDNIGHT':
            return "align-c";
          case 'POURCENTAGE':
            return "align-r";
          case 'BOOLEAN':
            return "align-c";
        }
        return "align-l";
      }
      var indexInClassificationFields = 0;
      var indexInClassificationProduitFields = 0;
      var indexInClassificationContrepartieFields = 0;
      var indexInClassificationEntiteFields = 0;
      var indexInClassificationProjetsFields = 0;
      for (var i = 0; i < classifications.length; i++) {
        var prefix = "classification";
        var fieldName = 'classificationFields';
        var cible = classifications[i].cible;
        if (cible === 'PRODUIT') {
          indexInClassificationFields = indexInClassificationProduitFields++;
        } else {
          prefix = "classification-" + cible;
          if (cible === 'COMPTE') {
            fieldName = 'classificationEntiteFields';
            indexInClassificationFields = indexInClassificationEntiteFields++;
          } else if (cible === 'PROJET') {
            fieldName = 'classificationProjetsFields';
            indexInClassificationFields = indexInClassificationProjetsFields++;
          } else {
            fieldName = 'classificationContrepartieFields';
            indexInClassificationFields = indexInClassificationContrepartieFields++;
          }
        }
        if (principal === undefined || principal === true && classifications[i].principal || principal === false && !classifications[i].principal) {
          columns.push({
            id: prefix + "-" + i,
            title: classifications[i].nom,
            template: '<div style="max-height: 200px; overflow-y: auto">' + '<div class="champ-additionnel" ng-repeat="imputation in model.' + fieldName + '[' + indexInClassificationFields + '].imputations">' + '  <span ng-if="model.' + fieldName + '[' + indexInClassificationFields + '].type==\'CLASSIFICATION\'" ng-class="{\'imputation\' : model.' + fieldName + '[' + indexInClassificationFields + '].multiple}">{{imputation.classificationValue}}</span>' + '  <span ng-if="model.' + fieldName + '[' + indexInClassificationFields + '].type==\'CLASSIFICATION\' && model.' + fieldName + '[' + indexInClassificationFields + '].repartition" class="imputation nowrap">{{imputation.imputation|number}}%</span>' + '  <span ng-if="model.' + fieldName + '[' + indexInClassificationFields + '].type==\'STRING\'">{{imputation.valueAsString}}</span>' + '  <span ng-if="model.' + fieldName + '[' + indexInClassificationFields + '].type==\'LONG\'"  class="align-r">{{imputation.valueAsLong|number}}</span>' + '  <span ng-if="model.' + fieldName + '[' + indexInClassificationFields + '].type==\'DOUBLE\'" class="align-r">{{imputation.valueAsDouble|number}}</span>' + '  <span ng-if="model.' + fieldName + '[' + indexInClassificationFields + '].type==\'DATEMIDNIGHT\'" class="align-c">{{imputation.valueAsDateMidnight|dateShort}}</span>' + '  <span ng-if="model.' + fieldName + '[' + indexInClassificationFields + '].type==\'POURCENTAGE\'"  class="align-r">{{imputation.valueAsPourcentage|number}}%</span>' + '  <span ng-if="model.' + fieldName + '[' + indexInClassificationFields + '].type==\'BOOLEAN\'">' + '    <i class="fa fa-check green align-c" ng-if="imputation.valueAsBoolean===true"></i>' + '    <i class="fa fa-times red align-c" ng-if="imputation.valueAsBoolean===false"></i>' + '  </span>' + '  <span ng-if="model.' + fieldName + '[' + indexInClassificationFields + '].type==\'GROUPE\'" class="align-c imputation">{{imputation.classificationValue}}</span>' + '  <span ng-if="model.' + fieldName + '[' + indexInClassificationFields + '].type==\'UTILISATEUR\'" class="align-c imputation">{{imputation.classificationValue}}</span>' + '</div></div>',
            cellClass: classificationFieldAlign(classifications[i]),
            attribute: '' + fieldName + '.' + indexInClassificationFields + '.imputationsAsString',
            sortable: true,
            subtotalGroup: withSubtotalGroup,
            maxWidth: '600px'
          });
        }
      }
    },
    /**
     * ajout des champs additionnels à columnGroups
     * @param classifications
     * @param columnGroups
     * @param principal true / false ou undefined pour les 2
     */
    addInventaireClassificationColumnsGroup: function addInventaireClassificationColumnsGroup(classifications, columnGroups, principal) {
      for (var i = 0; i < classifications.length; i++) {
        if (principal === undefined || principal === true && classifications[i].principal || principal === false && !classifications[i].principal) {
          var prefix = "classification";
          if (classifications[i].cible !== 'PRODUIT') {
            prefix = "classification-" + classifications[i].cible;
          }
          columnGroups.push({
            id: prefix + "-" + i,
            title: classifications[i].nom,
            columns: [prefix + "-" + i],
            visible: false
          });
        }
      }
    },
    /**
     *
     * Classifications et Champs UTILISATEUR
     *
     * place dans $scope :
     * changeClassification
     *     --> classificationValues les valeurs possibles
     * toutCocherClassificationValues()
     * toutDecocherClassificationValues()
     * changeClassification(init, subventionService)
     * toutCocherClassificationEntitesValues()
     * toutDecocherClassificationEntitesValues()
     * changeClassificationProjets()
     * toutCocherClassificationProjetsValues()
     * toutDecocherClassificationProjetsValues()
     *
     */
    initInventaireClassificationFilter: function initInventaireClassificationFilter($scope, classificationService, $element) {
      classificationService.findAll('PRODUIT').then(function (classifications) {
        $scope.classifications = _.filter(classifications, function (c) {
          return c.type == 'CLASSIFICATION' || c.type == 'UTILISATEUR';
        });
      });

      /**
       *
       * @param init
       * @param subventionService pour les subventions
       * ajoute la classification correspondant à $scope.params.classificationId dans $scope.classification
       * ajoute classificationValues
       */
      $scope.changeClassification = function (init, subventionService) {
        // reinitialise les selections de la liste
        var classificationId = $scope.params.classificationId;
        if (classificationId != null) {
          classificationService.findById(classificationId).then(function (classification) {
            $scope.classification = classification;
            if (classification == null) {
              $scope.params.classificationId = null;
              $scope.params.classificationValuesId = [];
              return;
            }
            // liste des valeurs possibles
            $scope.params.classificationId = classification.id;
            if (classification.type === 'UTILISATEUR' && subventionService) {
              subventionService.getUtilisateursPourTaches(false, true).then(function (users) {
                $scope.classificationUtilisateurValeurs = $scope.classificationValues = users;
                if (!init) {
                  $scope.toutCocherClassificationValues();
                }
              });
            } else {
              $scope.classificationValues = classification.valeurs;
              if (!init) {
                $scope.toutCocherClassificationValues();
              }
            }
          });
        } else {
          $scope.params.classificationValuesId = [];
        }
      };
      $scope.toutCocherClassificationValues = function () {
        var classificationValuesId = [];
        if ($scope.classification.type === 'UTILISATEUR') {
          classificationValuesId = _.map($scope.classificationUtilisateurValeurs, function (v) {
            return v.id;
          });
        } else {
          classificationValuesId = _.map($scope.classification.valeurs, function (v) {
            return v.id;
          });
        }
        $scope.params.classificationValuesId = classificationValuesId;
        triggerChangeEvent();
      };
      $scope.toutDecocherClassificationValues = function () {
        $scope.params.classificationValuesId = [];
        triggerChangeEvent();
      };
      classificationService.findAllClassifications('COMPTE').then(function (classifications) {
        $scope.classificationsEntites = classifications;
      });
      $scope.changeClassificationEntites = function (init) {
        // reinitialise les selections de la liste
        var classificationEntitesId = $scope.params.classificationEntitesId;
        if (classificationEntitesId != null) {
          classificationService.findById(classificationEntitesId).then(function (classification) {
            $scope.classificationEntites = classification;
            if (classification == null) {
              $scope.params.classificationEntitesId = null;
              $scope.params.classificationEntitesValuesId = [];
              return;
            }
            // liste des valeurs possibles
            $scope.classificationEntitesValues = classification.valeurs;
            $scope.params.classificationEntitesId = classification.id;
            if (!init) {
              $scope.toutCocherClassificationEntitesValues();
            }
          });
        } else {
          $scope.params.classificationEntitesValuesId = [];
        }
      };
      $scope.toutCocherClassificationEntitesValues = function () {
        var classificationEntitesValuesId = [];
        classificationEntitesValuesId = _.map($scope.classificationEntites.valeurs, function (v) {
          return v.id;
        });
        $scope.params.classificationEntitesValuesId = classificationEntitesValuesId;
        triggerChangeEvent();
      };
      $scope.toutDecocherClassificationEntitesValues = function () {
        $scope.params.classificationEntitesValuesId = [];
        triggerChangeEvent();
      };
      classificationService.findAllClassifications('PROJET').then(function (classifications) {
        $scope.classificationsProjets = classifications;
      });
      $scope.changeClassificationProjets = function (init) {
        // reinitialise les selections de la liste
        var classificationProjetsId = $scope.params.classificationProjetsId;
        if (classificationProjetsId != null) {
          classificationService.findById(classificationProjetsId).then(function (classification) {
            $scope.classificationProjets = classification;
            if (classification == null) {
              $scope.params.classificationProjetsId = null;
              $scope.params.classificationProjetsValuesId = [];
              return;
            }
            // liste des valeurs possibles
            $scope.classificationProjetsValues = classification.valeurs;
            $scope.params.classificationProjetsId = classification.id;
            if (!init) {
              $scope.toutCocherClassificationProjetsValues();
            }
          });
        } else {
          $scope.params.classificationProjetsValuesId = [];
        }
      };
      $scope.toutCocherClassificationProjetsValues = function () {
        var classificationProjetsValuesId = [];
        classificationProjetsValuesId = _.map($scope.classificationProjets.valeurs, function (v) {
          return v.id;
        });
        $scope.params.classificationProjetsValuesId = classificationProjetsValuesId;
        triggerChangeEvent();
      };
      $scope.toutDecocherClassificationProjetsValues = function () {
        $scope.params.classificationProjetsValuesId = [];
        triggerChangeEvent();
      };
      function triggerChangeEvent() {
        _.defer(function () {
          $element.find('.checkbox').trigger("change", {
            value: $scope.parameterValue
          });
        });
      }
    },
    /**
     * cf. UtilisateurPourTacheDTO
     * todo - a reprendre pour généraliser aux autres appli que subvention - recopie de ce qui est sur subventionService, car pas accessible de common
     * On veut tous les utilisateurs qui peuvent avoir des tâches : sur les compte parents ou enfants.
     * Soit on a une s
     * @param shortLabel si true Prénom + Nom
     @param compteId indique à partir de quel compte partir (compte de la subvention)
     */
    getUtilisateursPourTaches: function getUtilisateursPourTaches(shortLabel, compteId) {
      return $http.get('/rest/saisie/aide-subvention/utilisateurs-pour-taches', {
        params: {
          short: shortLabel,
          keepInactif: true,
          compteId: compteId
        }
      }).then(function (response) {
        return response.data;
      });
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/classification/classificationService.js
// module id = 2690
// module chunks = 13